// import { mapGetters } from "vuex";
// import { mapGetters } from "vuex";

export default {
  data() {
    return {
      // eslint-disable-next-line
      roleType: [
        "Apprentice",
        "Approver",
        "Assignee",
        "Coordinator",
        "Custodian",
        "Director",
        "Estimator",
        "Expert",
        "Focal",
        "Finance",
        "Health",
        "HSE",
        "Lead",
        "Legal",
        "Manager",
        "Medical",
        "Originator",
        "Planner",
        "Safety",
        "Social",
        "Supervisor",
        "Technical",
        "Trainee",
        "Writer",
        "Worker"
      ],
      roleAssign: ["Required", "Not Required"],
      roleCriticality: [
        "Business",
        "Environment",
        "Safety",
        "Social",
        "Technical"
      ],
      // eslint-disable-next-line
      roleTheme: [
        "Safety",
        "Management",
        "Planning",
        "Document Control",
        "Master Data",
        "Technical",
        "Business",
        "Governance"
      ]
    };
  }
};
